/** 24-hour `HH:MM`, or null when either part of the time is missing. */
export const formatTime = (time: { hour?: number; minute?: number }): string | null => {
  const { hour, minute } = time;
  if (hour === undefined || minute === undefined) return null;

  const date = new Date();
  date.setHours(hour, minute, 0, 0);

  return new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
};
